import { render, staticRenderFns } from "./OauthPrompt.vue?vue&type=template&id=ff00c68c&scoped=true&"
import script from "./OauthPrompt.vue?vue&type=script&lang=js&"
export * from "./OauthPrompt.vue?vue&type=script&lang=js&"
import style0 from "./OauthPrompt.vue?vue&type=style&index=0&id=ff00c68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff00c68c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
